import { render, staticRenderFns } from "./AcademyElement.vue?vue&type=template&id=236ea774&scoped=true&"
import script from "./AcademyElement.vue?vue&type=script&lang=js&"
export * from "./AcademyElement.vue?vue&type=script&lang=js&"
import style0 from "./AcademyElement.vue?vue&type=style&index=0&id=236ea774&scoped=true&lang=scss&"
import style1 from "./AcademyElement.vue?vue&type=style&index=1&id=236ea774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ea774",
  null
  
)

export default component.exports